<ng-container [formGroup]="formGroup">
  <lds-radio-group
    formControlName="question"
    name="{{ identifier }}"
    identifier="{{ identifier }}"
    [label]="label"
    orientation="horizontal"
    [options]="options"
    [isRequired]="isRequired"
    [validations]="{
      required: 'Please select an option'
    }">
  </lds-radio-group>
</ng-container>
